"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressText = void 0;
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var formatSize_1 = require("utils/helpers/formatSize");
var utils = require("utils/helpers/fileUpload");
var ProgressText = function (props) { return (React.createElement("div", { className: 'description-text' },
    (0, translation_1.getLocalization)('userfront/project/files/genericFileUploadModal/decriptiontext/uploadStatus'),
    ' ',
    "\u2013",
    ' ',
    props.uploadDone
        ? props.allDone
            ? (0, translation_1.getLocalization)('userfront/project/files/genericFileUploadModal/decriptiontext/done')
            : (0, translation_1.getLocalization)('userfront/project/files/genericFileUploadModal/decriptiontext/pleaseWaitWeAreNowProcessingData')
        : "".concat(utils.timeRemainingFormat(props.remaining), " ").concat((0, translation_1.getLocalization)('uploadstatusbar/time/left'), " \u2013 ").concat((0, formatSize_1.formatSize)(props.speed), "/s"))); };
exports.ProgressText = ProgressText;
